import { showApiError } from "@/utils";
import apiClient from "@/services/apiClient";

export const fetchRetrievalScores = (
  queries,
  webpageContent,
  BACKEND_URL,
) => {
  return apiClient
    .post(`${BACKEND_URL}/api/v1/retrieval-score/get-batch-scores`, {
      queries: queries,
      webpage_content: webpageContent,
    })
    .then((res) => res.data)
    .catch((err) => {
      console.error("Error fetching retrieval scores:", err);
      showApiError("Failed to fetch retrieval scores. Please try again.");
    });
};
